import React from "react";
import "./CSS/footer.css";

const Footer = () => {
  return (
    <footer className="main-footer">

      <div className="footer-container">

        {/* Left Side - Links */}
        {/* <div className="footer-links">
          <a href="#">Our Story</a>
          <a href="#">News</a>
          <a href="#">Webinars</a>
          <a href="#">Events</a>
          <a href="#">Partner Program</a>
          <a href="#">Careers</a>
          <a href="#">Resource Library</a>
          <a href="#">Security & Privacy</a>
        </div> */}

        {/* Right Side - Contact */}
        <div className="footer-contact">
          <p style={{ fontSize: "24px" }}>CONTACT US</p>
          <p>JBA Arcade, 2nd Floor <br />
            1st Cross, S S Circle <br />
            Ashok Nagar <br />
            Tumkuru-572103 <br />
            +91 9380606269
          </p>

          <br />
          <a href="mailto:Support@Schoolwave.in">
            Support@Schoolwave.in
          </a>

          {/* Social Icons */}
          <div className="social-icons">
            <i className="fab fa-facebook-f" ><a href="https://www.facebook.com/share/14aqMKDSNem/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"></a></i>
            <i className="fab fa-twitter"><a href="https://x.com/schoolwave25?s=21" target="_blank" rel="noopener noreferrer"></a></i>
            {/* <i className="fab fa-linkedin"><a href="https://www.linkedin.com/company/schoolwave" target="_blank" rel="noopener noreferrer"></a></i> */}
            <i className="fab fa-youtube"><a href="https://youtube.com/@schoolwave_official?si=ur5NZSZHDfmW5Kly" target="_blank" rel="noopener noreferrer"></a></i>
            <i className="fab fa-instagram"><a href="https://www.instagram.com/schoolwave25?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer"></a></i>
          </div>
        </div>

      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        © Copyright 2026 SchoolWave. All rights reserved.  SchoolWave a product of <a href="https://www.technotharanga.com/">Technotharanga</a>
      </div>

    </footer>
  );
}
export default Footer;